export enum GrandTypeEnum {
  Credentials = 'credentials',
  Token = 'token',
}
